import './TulzoLangAlbum.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faPlay
} from "@fortawesome/free-solid-svg-icons";

export function TulzoLangAlbum(props) {

  let i = 0;

  let listAlbum = props.listAlbum("Túlzó láng");
  
  return (
      <div className="album-container-div">
          <div className='album-div'>
            
            <div className='album-header'>

              <div className='album-cover-container' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`}}>

              </div>
              
              <div className='album-details-div'>
                <div className='album-title-div'><h1>Túlzó láng</h1></div>
                <div className='album-title-p-div'><p>Album • 2025</p></div>
                <div className='album-title-p2-div'><p>4 dal • 17 perc 8 másodperc</p></div> {/* 2 854,2 másodperc */}
                <div className='album-description-div'><p>Első album a zenekar életében.</p></div>
                
                <div className='album-control-btns'>
                  <span className='album-control-play-btn' onClick={() => {
                                    props.selectAlbum("Túlzó láng");
                                    props.openPlayerComponent();
                                    props.changeSong(15);
                                }}><FontAwesomeIcon className={"play-audio"} icon={faPlay} /> <span>Lejátszás</span></span>
                </div>
              </div>
              
              
            </div>

            <div className='album-songs-div'>

              { listAlbum.length > 0 && listAlbum.map((song) => {
                  i++;
                  
                return (
                  <>
                    <div className='album-song' key={song.id} onClick={() => props.changeSong(song.id)}>
                      <p>{i}</p>
                      <p className='album-song-title'>{song.title}</p>
                      <p>{song.length}</p>
                    </div>
                  </>
                  )}
                )
              }

            </div>
            
          </div>
      </div>
  );
}